<template>

<!-- <v-select   v-model="selected" :options="options" :reduce="(option) => option.id" @click="SetChange($event)" > -->
<v-select   v-model="selected" :options="options" :reduce="(option) => option.id" @update:modelValue="SetChange($event)" >

</v-select>

</template>





<script>
import vSelect from 'vue-select'
export default{
    name:"SimpleSelect",
    components:{
           "v-select" : vSelect 
    },
    data(){
  return {
    border:true,
    selected: null,
     options: [
      { label: 'One', id: 1 },
      { label: 'Two', id: 2 },
    ],
    isChange:0
    }
    },
    methods:{
      SetChange(e){
           
            const val = this.selected  

    },
      }
    
     
  
}
</script>
